var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0113 0.256836C4.62411 0.256836 0.256836 4.64024 0.256836 10.0473C0.256836 14.6387 3.40636 18.4915 7.65503 19.5496V13.0393H5.64365V10.0473H7.65503V8.75813C7.65503 5.42584 9.15761 3.88128 12.4172 3.88128C13.0352 3.88128 14.1016 4.00308 14.5378 4.12448V6.83645C14.3076 6.81217 13.9077 6.80003 13.411 6.80003C11.8116 6.80003 11.1936 7.40822 11.1936 8.98919V10.0473H14.3798L13.8323 13.0393H11.1936V19.7662C16.0236 19.1807 19.7662 15.053 19.7662 10.0473C19.7658 4.64024 15.3985 0.256836 10.0113 0.256836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.5e60cbe0ad5595286624aeecece54d99.svg";
export { ForwardRef as ReactComponent };